import React from 'react';
import type { IconProps } from '../types';

export const IconChart: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M3 16.5H17" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    <rect x="4.5" y="9" width="2.5" height="6.5" rx="0.5" stroke={color} strokeWidth="1.5"/>
    <rect x="8.75" y="6.5" width="2.5" height="9" rx="0.5" stroke={color} strokeWidth="1.5"/>
    <rect x="13" y="4" width="2.5" height="11.5" rx="0.5" stroke={color} strokeWidth="1.5"/>
  </svg>
);

